import { Box, Loader } from 'braid-design-system';

export const LoadingCard = () => (
  <Box padding="gutter" width="full">
    <Loader />
  </Box>
);
